import Globals from '../core/Globals';
import Utils from '../core/Utils';
import APIRequest from '../core/Request';

export default class APIApplicationItemFile {
  constructor(API) {
    this.api = API;
  }

  async download(userID, certProcID, sourceID, fileVersion) {
    const signedURLResp = await this.getSignURL(userID, certProcID, sourceID, fileVersion);

    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) {
      return signedURLResp;
    }

    return this._getRemoteFile(signedURLResp.body.fileURL);
  }

  async upload(file, userID, certProcID, sourceID, fileVersion) {
    if (file.size > Globals.API_MaxAllowedFileSize) {
      return { body: { message: 'The file you selected is too big! The maximum allowed size is 15mb.' }, statusCode: -1 };
    }

    const signedURLResp = await this._createSignURL(
      userID,
      certProcID,
      sourceID,
      fileVersion,
      file.type,
    );

    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) {
      return signedURLResp;
    }

    const signedURL = signedURLResp.body.fileURL;

    return this._uploadRemoteFile(file, signedURL);
  }

  async _createSignURL(
    userID,
    certProcID,
    sourceID,
    fileVersion,
    fileType,
  ) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certProcID}/applicationItem/${sourceID}/file/${fileVersion}?fileType=${fileType}`;
    return await req.exec();
  }

  async getSignURL(userID, certProcID, sourceID, fileVersion) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/user/${userID}/certification/${certProcID}/applicationItem/${sourceID}/file/${fileVersion}`;
    return await req.exec();
  }

  async _uploadRemoteFile(file, url) {
    const req = new APIRequest('PUT');
    req.baseURL = url;

    req.appendHeader('Content-type', file.type);
    req.appendHeader('Content-length', file.file.length);

    req.body = Utils.dataURItoBlob(file.file);
    req.bodyType = 'BINARY';
    return await req.exec();
  }

  async _getRemoteFile(url) {
    const request = new APIRequest('GET');
    request.baseURL = url;
    request.bodyType = 'BLOB';
    return await request.exec();
  }
}
